import React from "react";
import "./Dropdown.css";

const Dropdown = ({
  className = "",
  onClick = () => {},
  onChange = () => {},
  defaultValue,
  children
}) => (
  <select
    className={`generic-dropdown ${className}`}
    onClick={onClick}
    onChange={onChange}
    defaultValue={defaultValue}
  >
    {children}
  </select>
);

export default Dropdown;
